import { HowieKnowledgeGraphShell } from '../components/knowledge-graph/HowieKnowledgeGraphShell';

export default function GraphExplorerPage() {
  return <HowieKnowledgeGraphShell />;
}
